const theme = {
  token: {
    colorPrimary: '#1E90FF', // Vibrant Blue - for primary buttons, links, and active states
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#FF4500', // Orange-Red - for warnings, deletions
    colorInfo: '#87CEEB', // Light Sky Blue - for backgrounds, highlights
    colorTextBase: '#000080', // Navy Blue - for main headings and text
    colorText: '#4B4B4B', // Dark Gray - for subheadings and body text
    colorBgBase: '#F0F2F5', // Light Gray - for main app background
    colorBgContainer: '#ffffff',
    borderRadius: 8,
    fontSize: 14,
    fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Layout: {
      headerBg: '#1E90FF',
      headerHeight: 64,
      footerBg: '#F0F2F5',
    },
    Button: {
      primaryColor: '#ffffff',
      dangerColor: '#FF4500',
    },
    Card: {
      headerBg: '#F8F9FA',
    },
    Menu: {
      itemColor: '#ffffff',
      itemHoverColor: '#87CEEB',
      itemSelectedColor: '#FFA500',
    },
    Alert: {
      colorInfo: '#87CEEB',
      colorSuccess: '#52c41a',
      colorWarning: '#FFA500',
      colorError: '#FF4500',
    },
  },
};

export default theme; 